// @ts-nocheck

import React from 'react';
import styled, { css } from 'styled-components';

import TitleWithLine from '../TitleWithLine';

const StyledLabel = styled(TitleWithLine)`
  ${({ theme }) => css`
    margin: 0;
    color: ${theme.grids.colors.grey};
    font-size: 0.9em;

    .line {
      background-color: ${theme.grids.colors.lightgrey};
    }
  `}
`;

type GridsInfoBasketProps = {
  label: string | null;
};

const GridsInfoBasket = ({ label }: GridsInfoBasketProps) => {
  return label ? <StyledLabel text={label} /> : null;
};

export default GridsInfoBasket;
